const timer = document.querySelectorAll('.announcementbar-timer');
const bulletTimers = document.querySelectorAll('.selluxe-bullet-timer');

if(timer.length > 0) {
  timer.forEach(item => {
    setInterval(() => {
      const now = new Date();
      const totalSecondsInDay = 86400;
      const currentSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
      const remainingSeconds = totalSecondsInDay - currentSeconds;
      const days = Math.floor(remainingSeconds / 86400).toString().padStart(2, '0');
      const hours = Math.floor(remainingSeconds / 3600).toString().padStart(2, '0');
      const minutes = Math.floor((remainingSeconds % 3600) / 60).toString().padStart(2, '0');
      const seconds = (remainingSeconds % 60).toString().padStart(2, '0');
  
      item.innerText = `${days}:${hours}:${minutes}:${seconds}`;
    }, 1000);
  });
}

if(bulletTimers.length > 0) {
  bulletTimers.forEach(bulletTimer => {
    setInterval(() => {
      const now = new Date();
      const totalSecondsInDay = 86400;
      const currentSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
      const remainingSeconds = totalSecondsInDay - currentSeconds;
      const days = Math.floor(remainingSeconds / 86400).toString().padStart(2, '0');
      const hours = Math.floor(remainingSeconds / 3600).toString().padStart(2, '0');
      const minutes = Math.floor((remainingSeconds % 3600) / 60).toString().padStart(2, '0');
      const seconds = (remainingSeconds % 60).toString().padStart(2, '0');
  
      bulletTimer.innerText = `${hours}:${minutes}`;
    }, 1000);
  });
}

const stockContainer = document.querySelector('[data-stock]');
const announcementText = document.querySelector('.announcement-block .announcement-text');

console.log(stockContainer);

if(stockContainer) {
  const stocks = stockContainer.dataset.stock;

  if(announcementText) announcementText.innerHTML = announcementText.innerHTML.replace('[stocks]', stocks);
}